export const user_role = {
  admin: 1,
  vendor: 2,
  deliveryman: 3,
  customer: 4,
};

const localUrl = "http://192.168.1.5:5000";
const liveUrl = "https://backend.edelivery.tech";
const deliveryLocalUrl = "http://192.168.1.5:5001";
const deliveryLiveUrl = "https://edeliveryapp.nablean.com";

const isLive = true;

export const serverUrl = isLive ? liveUrl : localUrl;
export const server = isLive ? `${liveUrl}/api/v1/` : `${localUrl}/api/v1/`;
export const deliveryServer = isLive
  ? `${deliveryLiveUrl}/api/v1/`
  : `${deliveryLocalUrl}/api/v1/`;
